import { validHrmDate } from "./hrm-validation.js";
export const attendanceColumns = {
  employeeId: "Employee ID", date: "Date", siteId: "Site ID", events: "Events", flags: "Exceptions",
};
const bad = (message) => { throw Object.assign(new Error(message), { status: 400 }); };
export function attendanceLayout(input = {}) {
  const columns = input.columns === undefined ? Object.keys(attendanceColumns) : String(input.columns).split(",");
  if (!columns.length || columns.length > 5 || new Set(columns).size !== columns.length || columns.some((k) => !Object.hasOwn(attendanceColumns, k))) bad("Choose distinct allowed attendance columns.");
  const delimiter = input.delimiter || "comma";
  if (!["comma", "tab"].includes(delimiter)) bad("Choose comma or tab separation.");
  for (const key of ["from", "to"]) if (input[key] && !validHrmDate(input[key])) bad("Choose valid report dates.");
  if (input.from && input.to && input.to < input.from) bad("Report end must follow start.");
  return { columns, delimiter, from: input.from || "", to: input.to || "", siteId: input.siteId || "" };
}
export function attendanceCells(row, columns) {
  return columns.map((key) => key === "events" ? row.events.map((e) => `${e.time} ${e.event} (${e.source}; ${e.reviewState || "REVIEWED"}; source ${e.sourceRef || e.rawId || "unknown"})`).join("; ") : key === "flags" ? row.flags.join("; ") : row[key]);
}
export function attendanceCsv(rows, layout) {
  const cell = (v) => `"${String(v ?? "").replace(/^[=+@\-\t\r\n]/, "'$&").replaceAll('"', '""')}"`;
  const separator = layout.delimiter === "tab" ? "\t" : ",";
  return [layout.columns, ...rows.map((r) => attendanceCells(r, layout.columns))].map((r) => r.map(cell).join(separator)).join("\r\n");
}
